import React, { Component } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { connect } from "react-redux";
import { compose } from "redux";
import { logoutUser } from "../modules/actions";

class Home extends Component {
  componentDidMount() {
    this.props.logout();
  }
  render() {
    return (
      <div className="site-wrap">
        <Header page={'home'} />
        <div className="site-blocks-cover" data-aos="fade">
          <div className="container">
            <div className="row align-items-start align-items-md-center justify-content-end">
              <div className="col-md-12 text-center pt-5 pt-md-0">
                <h1 className="mb-2">Pelican Edu-Supply</h1>
                <div className="intro-text text-center">
                  <p className="mb-4">At Pelican Edu-Supply, we are passionate about supporting students, educators, and schools with the best educational tools and supplies. Whether you're looking for <b>textbooks, stationery and learning materials</b>, we strive to provide a comprehensive range of products designed to enhance learning experiences and foster academic growth.</p>
                  <p>
                    <a href="login" className="btn btn-sm btn-primary">Shop Now</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* YouTube Video Section */}
        {/* <div className="container my-5 text-center">
          <h2 className="mb-4">More about us</h2>
          <div className="video-container" style={{ position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden", maxWidth: "100%", background: "#000" }}>
            <iframe
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
              src="https://www.youtube.com/embed/fCELN0CcxNk"
              title="Pelican Edu-Supply Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen>
            </iframe>
          </div>
        </div> */}
        <div className="site-section block-3 site-blocks-2 bg-light">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 site-section-heading text-center">
                <h2>More about us</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="video-container" style={{ position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden", maxWidth: "100%", background: "#000" }}>
                  <iframe
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                    src="https://www.youtube.com/embed/fCELN0CcxNk"
                    title="Pelican Edu-Supply Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen>
                  </iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
}

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logoutUser()),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Home);